export default "__VITE_ASSET__Bzf7JuFu__"